export const formatValidationProcessName = (
  validationProcess: string | null | undefined,
): string => {
  return validationProcess
    ? validationProcess
        .split('_')
        .map((word) => word.charAt(0).toLocaleUpperCase() + word.slice(1).toLocaleLowerCase())
        .join(' ')
    : '';
};
